import { Radio as RadioA } from 'antd';
import cs from 'classnames';
import type { ComponentProps, ReactNode } from 'react';

import { useTranslation } from 'react-i18next';
import { Icon } from '../../icons';
import { Tooltip } from '../../tooltip';
import styles from './radio-button.module.css';

type P = {
  children?: ReactNode;
  icon?: ReactNode;
  size?: 'large' | 'middle' | 'small';
  tooltip?: string;
} & ComponentProps<typeof RadioA.Button>;

const RadioButton = ({ children, className, icon, size = 'large', tooltip, ...rest }: P) => {
  const { t } = useTranslation();

  return (
    <RadioA.Button
      className={cs(styles['radio-button'], className, {
        [styles['radio-button--large'] ?? '']: size === 'large',
        [styles['radio-button--middle'] ?? '']: size === 'middle',
        [styles['radio-button--small'] ?? '']: size === 'small',
      })}
      {...rest}
    >
      {icon ?? null}
      {typeof children === 'string' ? t(children) : children}
      {tooltip ? (
        <Tooltip title={tooltip}>
          <Icon icon="information-line" />
        </Tooltip>
      ) : null}
    </RadioA.Button>
  );
};

export default RadioButton;
